import './template_legal.css'
